<template>
  <v-hover v-slot="data">
    <v-card flat>
      <v-img
        v-if="item.Image"
        :class="hover && data.hover ? 'hover-zoom hover-zoom-active' : 'hover-zoom'"
        :height="imageHeight"
        :src="item.Image"
        class="white--text align-end"
        gradient="to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5)"
      >
        <div
          v-if="item.OriginalPrice && item.OfferPrice"
          class="brand-green-light text-center d-flex align-center justify-center pa-2"
          style="min-width: 115px; min-height: 37px; position: absolute; right: 15px; top: 15px;"
        >
          <v-icon
            class="mr-1"
            color="brand-green-dark"
          >
            mdi-tag
          </v-icon>

          <span class="brand-text-title brand-green-dark--text">
            {{ item.OriginalPrice }}€
          </span>

          <v-icon color="brand-green-dark lighten-3">
            mdi-arrow-right-thin
          </v-icon>

          <span class="brand-text-title brand-green-dark--text text--lighten-3">
            {{ item.OfferPrice }}€
          </span>
        </div>

        <v-container fluid>
          <v-row>
            <v-col cols="12">
              <v-card-title
                v-if="item.Name"
                :class="{'pb-0': !item.Desc}"
                class="px-0 pt-0"
              >
                <div
                  class="overflow-hidden text-no-wrap brand-text-heading brand-beige-light--text"
                  style="text-overflow: ellipsis;"
                >
                  {{ item.Name }}
                </div>
              </v-card-title>

              <v-card-subtitle
                v-if="item.Desc"
                class="px-0 pb-0"
              >
                <div
                  class="overflow-hidden text-no-wrap brand-beige-light--text mt-1"
                  style="text-overflow: ellipsis;"
                >
                  {{ item.Desc }}
                </div>
              </v-card-subtitle>
            </v-col>
          </v-row>
        </v-container>
      </v-img>
    </v-card>
  </v-hover>
</template>

<script>
import OfferCardMixin from '@/theme/default/views/home/OfferCard.js'

export default {
  name    : 'OfferCard',
  mixins  : [OfferCardMixin],
  computed: {
    imageHeight() {
      if (this.$vuetify.breakpoint.xs) return 160
      if (this.$vuetify.breakpoint.sm) return 180
      if (this.$vuetify.breakpoint.md) return 200
      if (this.$vuetify.breakpoint.lg) return 240

      return 290
    }
  }
}
</script>

<style scoped src="@/theme/default/views/home/OfferCard.css"></style>
<style scoped>
</style>
